import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Typography } from '@inference/ui';
import { AuthShell } from '@/lib/auth-shell';
import './styles.css';

/** Local Vite entry only — Auth0 hosts the real screen bundles. */
function DevIndex() {
  return (
    <AuthShell title="Nava Universal Login" subtitle="Custom Auth0 screens for Inference">
      <div className="flex flex-col gap-space-16">
        <Typography variant="text-md" className="text-tertiary">
          This preview mounts the shared auth layout used by signup, sign-in, password reset, and
          invitation acceptance. Screen bundles are built separately and deployed to Auth0 ACUL.
        </Typography>
        <Typography variant="text-sm" className="text-tertiary">
          To exercise a screen against live Auth0 context, run{' '}
          <code className="text-tertiary">auth0 acul dev</code> from{' '}
          <code className="text-tertiary">apps/acul</code>.
        </Typography>
      </div>
    </AuthShell>
  );
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <DevIndex />
  </StrictMode>,
);
